// @systeme: contrat
// Les listes : la liste de courses (une par foyer) et les listes libres. Un article se
// coche d'un doigt ; les doublons se fondent ; le rayon se devine pour trier dans l'ordre
// du magasin ; ce qu'on rachète souvent est proposé. Une liste se partage par un lien
// secret, sans compte, en lecture et en cochage.
import { z } from 'zod';
import { SchemaRayon, SchemaTypeListe } from '../enumerations.js';
import { SchemaInstant } from './elements.js';
const SchemaLibelle = z.string().trim().min(1, { error: 'Il manque un mot.' }).max(120);
export const SchemaArticle = z.object({
    id: z.uuid(),
    listeId: z.uuid(),
    libelle: z.string(),
    quantite: z.string().nullable(),
    rayon: SchemaRayon.nullable(),
    coche: z.boolean(),
    cocheLe: SchemaInstant.nullable(),
    /** Revient tout seul à chaque tournée : on le décoche au lieu de le retirer. */
    recurrent: z.boolean(),
    creeLe: SchemaInstant,
});
export const SchemaListe = z.object({
    id: z.uuid(),
    espaceId: z.uuid(),
    nom: z.string(),
    type: SchemaTypeListe,
    /** Le jeton du lien de partage, s'il a été créé. Le client construit l'adresse. */
    jetonPartage: z.string().nullable(),
    articles: z.array(SchemaArticle),
    nombreAFaire: z.number().int(),
    creeLe: SchemaInstant,
});
export const SchemaResumeListe = SchemaListe.omit({ articles: true });
export const SchemaCreationListe = z.object({
    nom: z.string().trim().min(1, { error: 'Il manque un nom.' }).max(80),
});
export const SchemaCreationArticle = z.object({
    libelle: SchemaLibelle,
    quantite: z.string().trim().max(30).nullable().optional(),
    rayon: SchemaRayon.nullable().optional(),
});
export const SchemaMajArticle = z
    .object({
    libelle: SchemaLibelle,
    quantite: z.string().trim().max(30).nullable(),
    rayon: SchemaRayon.nullable(),
    coche: z.boolean(),
    recurrent: z.boolean(),
})
    .partial()
    .refine((v) => Object.keys(v).length > 0, { error: 'Rien à modifier.' });
/** Ce qu'on rachète souvent et qui n'est pas déjà sur la liste. */
export const SchemaSuggestion = z.object({
    libelle: z.string(),
    rayon: SchemaRayon.nullable(),
    /** Combien de fois cet article a été coché par le passé. */
    fois: z.number().int(),
});
/** La liste vue par le lien de partage : sans compte, sans identifiant de foyer. */
export const SchemaListePartagee = z.object({
    nom: z.string(),
    type: SchemaTypeListe,
    articles: z.array(SchemaArticle.omit({ listeId: true })),
});
//# sourceMappingURL=listes.js.map